import { addModal } from 'core/notifications';
import i18n from 'i18next';

export default async ({
  title, body, onDeleteButtonClick,
}) => {
  const actions = [
    {
      action: 'cancel',
      element: 'button',
      text: i18n.t('cancel'),
      variant: 'ghost',
    },
    {
      action: 'delete',
      element: 'button',
      color: 'negative',
      text: i18n.t('delete'),
    },
  ];

  const { type, payload } = await addModal({
    actions,
    title,
    body,
    hasCloseButton: true,
  });

  if (type !== 'delete') return;

  await onDeleteButtonClick({ payload });
};
